// Main path
export const LANDING_PATH = '/'

export enum AccessLevel {
  USER = 50,
  AFFILIATE=60,
  ADMIN = 75,
  SUPERUSER = 99,
}